const EcommerceState = {
    ecomOrders:    { data: [] },
    ecomCarts:     { data: [] },
    wishlistItems: { data: [] },
};

export default EcommerceState;
